import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6259c152"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "study-task-meeting" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mask" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "加入会议", -1));
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
const _hoisted_5 = { class: "time" };
const _hoisted_6 = { class: "id" };
const _hoisted_7 = { class: "password" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "remind" }, "温馨提示：请提前5分钟进入会议会议", -1));
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    props: {
        desc: {
            type: String,
            default: ''
        },
        cover: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ""
        },
        time: {
            type: String,
            default: ""
        },
        meetingNumber: {
            type: String,
            default: ""
        },
        meetingPass: {
            type: String,
            default: ""
        }
    },
    setup(__props) {
        const props = __props;
        const copy = val => {
            let oInput = document.createElement('input');
            oInput.value = val;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy");
            oInput.remove();
            Toast('复制成功');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("div", { class: "desc" }, _toDisplayString(__props.desc), 513), [
                    [_vShow, __props.desc]
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: "cover",
                    style: _normalizeStyle({ backgroundImage: 'url(' + __props.cover + ')' })
                }, _hoisted_4, 4), [
                    [_vShow, __props.cover]
                ]),
                _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(__props.time), 1),
                _createElementVNode("p", _hoisted_6, [
                    _createTextVNode("会议ID：" + _toDisplayString(__props.meetingNumber), 1),
                    _createElementVNode("span", {
                        class: "copy",
                        onClick: _cache[0] || (_cache[0] = ($event) => (copy(__props.meetingNumber)))
                    }, "复制")
                ]),
                _createElementVNode("p", _hoisted_7, [
                    _createTextVNode("会议密码：" + _toDisplayString(__props.meetingPass), 1),
                    _createElementVNode("span", {
                        class: "copy",
                        onClick: _cache[1] || (_cache[1] = ($event) => (copy(__props.meetingPass)))
                    }, "复制")
                ]),
                _hoisted_8
            ]));
        };
    }
});
